import {
    getItemSummaryCurrentTimedPlusEndTime,
    getItemSummaryIsPaused,
    getItemSummaryIsTimedPlusAuction,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import { useAppSelector } from '@/redux/hooks';
import { useEffect, useState } from 'react';
import ms from 'ms';

const TWENTY_FOUR_HOURS_IN_SECONDS = ms('24h') / 1000;

export const useCanRetractTimedPlusAuctionBid = (itemId: number): boolean => {
    const isTimedPlusAuction = useAppSelector((state) => getItemSummaryIsTimedPlusAuction(state, itemId));
    const isLotWithdrawn = useAppSelector((state) => getItemSummaryIsPaused(state, itemId));
    const lotEndTime = useAppSelector((state) => getItemSummaryCurrentTimedPlusEndTime(state, itemId));
    // lotEndTime is in seconds
    const isWithin24Hours = lotEndTime - TWENTY_FOUR_HOURS_IN_SECONDS <= Date.now() / 1000;
    const [canRetract, setCanRetract] = useState(isTimedPlusAuction && !isWithin24Hours);

    useEffect(() => {
        // lotEndTime is in seconds
        const isWithin24Hours = lotEndTime - TWENTY_FOUR_HOURS_IN_SECONDS <= Date.now() / 1000;
        setCanRetract(isTimedPlusAuction && !isWithin24Hours && !isLotWithdrawn);
    }, [isLotWithdrawn, isTimedPlusAuction, lotEndTime]);

    return canRetract;
};
